import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomSelectComponent } from './custom-select/custom-select.component';
import { AcIconArrowDownComponent } from './ac-icon-arrow-down/ac-icon-arrow-down.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BasicSelectComponent } from './basic-select/basic-select.component';
import { AcIconArrowRightComponent } from './ac-icon-arrow-right/ac-icon-arrow-right.component';
import { ValidationMessageComponent } from './validation-message/validation-message.component';
import { MessageModalComponent } from './message-modal/message-modal.component';
import { LoadingOverlayComponent } from './loading-overlay/loading-overlay.component';
import { PaginationSelectComponent } from './pagination-select/pagination-select.component';
import { SafePipe } from '../core/pipes/safe.pipe';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { GateBlockModalComponent } from './gate-block-modal/gate-block-modal.component';
import { OptionalLabelComponent } from './optional-label/optional-label.component';
import { ContentModalComponent } from './content-modal/content-modal.component';
import { CustomMultiSelectComponent } from './custom-multi-select/custom-multi-select.component';
import { TruncatePipe } from '../core/pipes/truncate.pipe';
import { DateAgoPipe } from '../core/pipes/date-ago.pipe';
import { LineBreakReplacePipe } from '../core/pipes/line-break-replace.pipe';
import { FormPageLoadingOverlayComponent } from './form-page-loading-overlay/form-page-loading-overlay.component';
import { DetailsPageLoadingOverlayComponent } from './details-page-loading-overlay/details-page-loading-overlay.component';
import { LoadingGifImageComponent } from './loading-gif-image/loading-gif-image.component';
import { MarkdownPipe } from '../core/pipes/markdown.pipe';
import { PermissionDirective } from '../core/directives/permission.directive';
import { ExchangeRatePermissionDirective } from '../core/directives/exchange-rate-permission.directive';
import { ExchangeRateFlatDirective } from '../core/directives/exchange-rate-flat.directive';
import { DefaultCurrencyPipe } from '../core/pipes/default-currency.pipe';
import { LoadingModalComponent } from './loading-modal/loading-modal.component';
import { LoadingOverlayFullComponent } from './loading-overlay-full/loading-overlay-full.component';
import { GuestHeaderComponent } from './guest-header/guest-header.component';
import { ExchangeRateFieldComponent } from './exchange-rate-field/exchange-rate-field.component';
import { SplitByCapitalPipe } from '../core/pipes/split-by-capital.pipe';
import { FilterAndSortActionButtonsComponent } from './filter-and-sort-action-buttons/filter-and-sort-action-buttons.component';
import { ToastComponent } from './toast/toast.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TermsModalComponent } from './terms-modal/terms-modal.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { EnterPasswordModalComponent } from './enter-password-modal/enter-password-modal.component';
import { RequiredLabelComponent } from './required-label/required-label.component';
import { StatusBadgePipe } from '../core/pipes/status-badge.pipe';
import { CaretIconComponent } from './caret-icon/caret-icon.component';
import { FormatNullableTextPipe } from '../core/pipes/format-nullable-text.pipe';
import { TagsInputComponent } from './tags-input/tags-input.component';
import { DisablePasteDirective } from '../core/directives/disable-paste.directive';
import { FilePreviewBtnComponent } from './file-preview-btn/file-preview-btn.component';
import { YesOrNoTextPipe } from '../core/pipes/yes-or-no-text.pipe';
import { ModalLoadingOverlayComponent } from './modal-loading-overlay/modal-loading-overlay.component';
import { ModalLoadingOverlayCloseComponent } from './modal-loading-overlay-close/modal-loading-overlay-close.component';
import { TitleCasePipe } from '../core/pipes/title-case.pipe';
import { PadLeftPipe } from '../core/pipes/pad-left.pipe';
import { ColorDivComponent } from './color-div/color-div.component';
import { CustomSearchWidgetComponent } from './custom-search-widget/custom-search-widget.component';
import { DisableElementDirective } from '../core/directives/disable-element.directive';
import { ConditionalBackgroundColorDirective } from '../core/directives/conditional-background-color.directive';
import { ImageSelectInputComponent } from './image-select-input/image-select-input.component';
import { CustomCurrencyPipe } from '../core/pipes/custom-currency.pipe';
import { MoneyPipe } from '../core/pipes/money.pipe';
import { TenderMethodChoiceComponent } from './tender-method-choice/tender-method-choice.component';
import { CurrencyViewChoiceComponent } from './currency-view-choice/currency-view-choice.component';
import { CurrencyViewBannerComponent } from './currency-view-banner/currency-view-banner.component';
import { CurrencyChoiceComponent } from './currency-choice/currency-choice.component';
import { PercentageBasedBgPipe } from '../core/pipes/percentage-based-bg.pipe';
import { PortalDirective } from '../core/directives/portal.directive';
import { FileDownloadPathPipe } from '../core/pipes/file-download-path.pipe';
import { DateInputComponent } from './date-input/date-input.component';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { FeatureIconComponent } from './feature-icon/feature-icon.component';
import { AffiliationDirective } from '../core/directives/affiliation.directive';
import { AgePipe } from '../core/pipes/age.pipe';
import { TrueFalseInputComponent } from './true-false-input/true-false-input.component';
import { StaticProgressBarComponent } from './static-progress-bar/static-progress-bar.component';
import { WebcamModule } from 'ngx-webcam';
import { PlaceholderComponent } from './placeholder/placeholder.component';
import { StatusInputComponent } from './status-input/status-input.component';
import { TitleInputComponent } from './title-input/title-input.component';
import { GenderInputComponent } from './gender-input/gender-input.component';
import { FileInputComponent } from './file-input/file-input.component';
import { PhotoCameraModalComponent } from './photo-camera-modal/photo-camera-modal.component';
import { TextInputComponent } from './text-input/text-input.component';
import { NumberInputComponent } from './number-input/number-input.component';
import { TextareaInputComponent } from './textarea-input/textarea-input.component';
import { EmailInputComponent } from './email-input/email-input.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { OutbountLinkIconComponent } from './outbount-link-icon/outbount-link-icon.component';
import { TimeInputComponent } from './time-input/time-input.component';
import { MoneyInputComponent } from './money-input/money-input.component';
import { DisabledLabelComponent } from './disabled-label/disabled-label.component';
import { NumberToWordsPipe } from '../core/pipes/number-to-words.pipe';
import { NgxEditorModule } from 'ngx-editor';
import { StripHtmlPipe } from '../core/pipes/strip-html.pipe';
import { TruckTypeInputComponent } from './truck-type-input/truck-type-input.component';
import { TransmissionInputComponent } from './transmission-input/transmission-input.component';
import { CurrencyInputComponent } from './currency-input/currency-input.component';
import { PasswordInputComponent } from './password-input/password-input.component';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { ClearingCompanyInputComponent } from './clearing-company-input/clearing-company-input.component';
import { UnitOfMeasureInputComponent } from './unit-of-measure-input/unit-of-measure-input.component';
import { PurposeActionInputComponent } from './purpose-action-input/purpose-action-input.component';
import { LoadTypeActionInputComponent } from './load-type-action-input/load-type-action-input.component';
import { CountryInputComponent } from './country-input/country-input.component';
import { LoadingFormatInputComponent } from './loading-format-input/loading-format-input.component';
import { CommodityInputComponent } from './commodity-input/commodity-input.component';
import { WarehouseInputComponent } from './warehouse-input/warehouse-input.component';
import { ParkingBaySectionInputComponent } from './parking-bay-section-input/parking-bay-section-input.component';
import { CommodityCategoryInputComponent } from './commodity-category-input/commodity-category-input.component';
import { PackagingInputComponent } from './packaging-input/packaging-input.component';
import { TransporterInputComponent } from './transporter-input/transporter-input.component';
import { CargoCategoryInputComponent } from './cargo-category-input/cargo-category-input.component';
import { PurposeInputComponent } from './purpose-input/purpose-input.component';
import { ImporterInputComponent } from './importer-input/importer-input.component';
import { PermissionNameInputComponent } from './permission-name-input/permission-name-input.component';
import { PermissionLevelPipe } from '../core/pipes/permission-level.pipe';
import { PermissionLevelInputComponent } from './permission-level-input/permission-level-input.component';
import { PermissionInputComponent } from './permission-input/permission-input.component';
import { RoleInputComponent } from './role-input/role-input.component';
import { UserInputComponent } from './user-input/user-input.component';
import { ClearingAgentInputComponent } from './clearing-agent-input/clearing-agent-input.component';
import { PhysicalExamInputCategoryComponent } from './physical-exam-input/physical-exam-category-input.component';
import { LoadTypeInputComponent } from './load-type-input/load-type-input.component';
import { ContainerSizeInputComponent } from './container-size-input/container-size-input.component';
import { PhysicalExaminationGroupInputComponent } from './physical-examination-group-input/physical-examination-group-input.component';
import { ClientInputComponent } from './client-input/client-input.component';
import { CreateImporterModalComponent } from './create-importer-modal/create-importer-modal.component';
import { LoadingOverlayModalComponent } from './loading-overlay-modal/loading-overlay-modal.component';
import { CreateTransporterModalComponent } from './create-transporter-modal/create-transporter-modal.component';
import { CreateClearingCompanyModalComponent } from './create-clearing-company-modal/create-clearing-company-modal.component';
import { ContainerTransactionTypeInputComponent } from './container-transaction-type-input/container-transaction-type-input.component';
import { ContainerTransportationInputComponent } from './container-transportation-input/container-transportation-input.component';
import { LoadPortInputComponent } from './load-port-input/load-port-input.component';
import { ShippingLineInputComponent } from './shipping-line-input/shipping-line-input.component';
import { TownInputComponent } from './town-input/town-input.component';
import { LoadingBayInputComponent } from './loading-bay-input/loading-bay-input.component';
import { GradeInputComponent } from './grade-input/grade-input.component';
import { ParkingBayInputComponent } from './parking-bay-input/parking-bay-input.component';
import { StackInputComponent } from './stack-input/stack-input.component';
import { WarehouseTransactionTypeInputComponent } from './warehouse-transaction-type-input/warehouse-transaction-type-input.component';
import { BatchNumberInputComponent } from './batch-number-input/batch-number-input.component';
import { WarehouseTransactionGroupInputComponent } from './warehouse-transaction-group-input/warehouse-transaction-group-input.component';
import { ContainerTransactionStatusInputComponent } from './container-transaction-status-input/container-transaction-status-input.component';
import { OwnerPricesComponent } from './owner-prices/owner-prices.component';

@NgModule({
  declarations: [
    OwnerPricesComponent,
    CustomSelectComponent,
    AcIconArrowDownComponent,
    BasicSelectComponent,
    AcIconArrowRightComponent,
    ValidationMessageComponent,
    MessageModalComponent,
    LoadingOverlayComponent,
    PaginationSelectComponent,
    SafePipe,
    PermissionLevelPipe,
    PermissionDirective,
    ExchangeRatePermissionDirective,
    DisableElementDirective,
    ConditionalBackgroundColorDirective,
    ExchangeRateFlatDirective,
    AffiliationDirective,
    DefaultCurrencyPipe,
    TruncatePipe,
    MarkdownPipe,
    AgePipe,
    DateAgoPipe,
    StatusInputComponent,
    PermissionNameInputComponent,
    ClientInputComponent,
    CreateImporterModalComponent,
    CreateTransporterModalComponent,
    CreateClearingCompanyModalComponent,
    TitleCasePipe,
    StatusBadgePipe,
    PadLeftPipe,
    StripHtmlPipe,
    FormatNullableTextPipe,
    SplitByCapitalPipe,
    LineBreakReplacePipe,
    ConfirmModalComponent,
    GateBlockModalComponent,
    OptionalLabelComponent,
    ContentModalComponent,
    CustomMultiSelectComponent,
    DetailsPageLoadingOverlayComponent,
    FormPageLoadingOverlayComponent,
    LoadingGifImageComponent,
    LoadingModalComponent,
    GuestHeaderComponent,
    LoadingOverlayFullComponent,
    ExchangeRateFieldComponent,
    FilterAndSortActionButtonsComponent,
    ConditionalBackgroundColorDirective,
    ToastComponent,
    SpinnerComponent,
    TermsModalComponent,
    EnterPasswordModalComponent,
    RequiredLabelComponent,
    CaretIconComponent,
    TagsInputComponent,
    DisablePasteDirective,
    FilePreviewBtnComponent,
    PlaceholderComponent,
    LoadingOverlayModalComponent,
    YesOrNoTextPipe,
    ModalLoadingOverlayComponent,
    ModalLoadingOverlayCloseComponent,
    ColorDivComponent,
    CustomCurrencyPipe,
    MoneyPipe,
    CurrencyChoiceComponent,
    TenderMethodChoiceComponent,
    CurrencyViewChoiceComponent,
    CurrencyViewBannerComponent,
    CustomSearchWidgetComponent,
    ImageSelectInputComponent,
    PercentageBasedBgPipe,
    PortalDirective,
    FileDownloadPathPipe,
    DateInputComponent,
    SvgIconComponent,
    PurposeActionInputComponent,
    CountryInputComponent,
    LoadTypeActionInputComponent,
    FeatureIconComponent,
    TrueFalseInputComponent,
    PhotoCameraModalComponent,
    GenderInputComponent,
    TitleInputComponent,
    StaticProgressBarComponent,
    FileInputComponent,
    TextInputComponent,
    NumberInputComponent,
    TextareaInputComponent,
    EmailInputComponent,
    PhoneInputComponent,
    PasswordInputComponent,
    BackButtonComponent,
    OutbountLinkIconComponent,
    TimeInputComponent,
    TruckTypeInputComponent,
    WarehouseTransactionTypeInputComponent,
    TransporterInputComponent,
    ImporterInputComponent,
    PhysicalExaminationGroupInputComponent,
    WarehouseTransactionGroupInputComponent,
    PhysicalExamInputCategoryComponent,
    LoadTypeInputComponent,
    ContainerSizeInputComponent,
    PermissionLevelInputComponent,
    PermissionInputComponent,
    ContainerTransactionTypeInputComponent,
    ContainerTransactionStatusInputComponent,
    ContainerTransportationInputComponent,
    LoadPortInputComponent,
    ShippingLineInputComponent,
    TownInputComponent,
    GradeInputComponent,
    StackInputComponent,
    LoadingBayInputComponent,
    RoleInputComponent,
    UserInputComponent,
    ClearingAgentInputComponent,
    CargoCategoryInputComponent,
    BatchNumberInputComponent,
    PurposeInputComponent,
    ClearingCompanyInputComponent,
    UnitOfMeasureInputComponent,
    LoadingFormatInputComponent,
    CommodityInputComponent,
    WarehouseInputComponent,
    ParkingBaySectionInputComponent,
    CommodityCategoryInputComponent,
    PackagingInputComponent,
    TransmissionInputComponent,
    MoneyInputComponent,
    CurrencyInputComponent,
    ParkingBayInputComponent,
    DisabledLabelComponent,
    NumberToWordsPipe,
  ],

  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    WebcamModule,
    NgxEditorModule.forRoot({
      locals: {
        bold: 'Bold',
        italic: 'Italic',
        code: 'Code',
        blockquote: 'Blockquote',
        underline: 'Underline',
        strike: 'Strike',
        bullet_list: 'Bullet List',
        ordered_list: 'Ordered List',
        heading: 'Heading',
        h1: 'Header 1',
        h2: 'Header 2',
        h3: 'Header 3',
        h4: 'Header 4',
        h5: 'Header 5',
        h6: 'Header 6',
        align_left: 'Left Align',
        align_center: 'Center Align',
        align_right: 'Right Align',
        align_justify: 'Justify',
        text_color: 'Text Color',
        background_color: 'Background Color',
        url: 'URL',
        text: 'Text',
        openInNewTab: 'Open in new tab',
        insert: 'Insert',
        altText: 'Alt Text',
        title: 'Title',
        remove: 'Remove',
        enterValidUrl: 'Please enter a valid URL',
      },
    }),
    ReactiveFormsModule,
    NgxExtendedPdfViewerModule,
  ],

  exports: [
    OwnerPricesComponent,
    NgbModule,
    CustomSelectComponent,
    BasicSelectComponent,
    AcIconArrowDownComponent,
    ValidationMessageComponent,
    LoadingOverlayComponent,
    FormsModule,
    TruncatePipe,
    MarkdownPipe,
    SafePipe,
    PermissionLevelPipe,
    TitleCasePipe,
    PadLeftPipe,
    StripHtmlPipe,
    StatusBadgePipe,
    SplitByCapitalPipe,
    FormatNullableTextPipe,
    LineBreakReplacePipe,
    AgePipe,
    DateAgoPipe,
    CustomCurrencyPipe,
    MoneyPipe,
    CurrencyChoiceComponent,
    TenderMethodChoiceComponent,
    CurrencyViewChoiceComponent,
    CurrencyViewBannerComponent,
    PhotoCameraModalComponent,
    PermissionDirective,
    ExchangeRatePermissionDirective,
    ExchangeRateFlatDirective,
    DefaultCurrencyPipe,
    ReactiveFormsModule,
    ToastComponent,
    WebcamModule,
    PaginationSelectComponent,
    OptionalLabelComponent,
    RequiredLabelComponent,
    ContentModalComponent,
    CustomMultiSelectComponent,
    LoadingGifImageComponent,
    DetailsPageLoadingOverlayComponent,
    FormPageLoadingOverlayComponent,
    LoadingModalComponent,
    GuestHeaderComponent,
    LoadingOverlayFullComponent,
    FilterAndSortActionButtonsComponent,
    ExchangeRateFieldComponent,
    TermsModalComponent,
    SpinnerComponent,
    EnterPasswordModalComponent,
    NgxExtendedPdfViewerModule,
    CaretIconComponent,
    TagsInputComponent,
    DisablePasteDirective,
    YesOrNoTextPipe,
    PurposeActionInputComponent,
    CountryInputComponent,
    LoadTypeActionInputComponent,
    FilePreviewBtnComponent,
    ModalLoadingOverlayComponent,
    ColorDivComponent,
    CustomSearchWidgetComponent,
    PlaceholderComponent,
    BatchNumberInputComponent,
    LoadingOverlayModalComponent,
    DisableElementDirective,
    ImageSelectInputComponent,
    StatusInputComponent,
    PermissionNameInputComponent,
    ClientInputComponent,
    CreateImporterModalComponent,
    CreateTransporterModalComponent,
    CreateClearingCompanyModalComponent,
    PermissionInputComponent,
    ContainerTransactionTypeInputComponent,
    ContainerTransactionStatusInputComponent,
    ContainerTransportationInputComponent,
    LoadPortInputComponent,
    ShippingLineInputComponent,
    TownInputComponent,
    GradeInputComponent,
    StackInputComponent,
    LoadingBayInputComponent,
    RoleInputComponent,
    UserInputComponent,
    ClearingAgentInputComponent,
    PercentageBasedBgPipe,
    AffiliationDirective,
    PortalDirective,
    FileDownloadPathPipe,
    DateInputComponent,
    SvgIconComponent,
    StaticProgressBarComponent,
    FeatureIconComponent,
    TrueFalseInputComponent,
    GenderInputComponent,
    TitleInputComponent,
    FileInputComponent,
    TextInputComponent,
    NumberInputComponent,
    TextareaInputComponent,
    CurrencyInputComponent,
    EmailInputComponent,
    PhoneInputComponent,
    PasswordInputComponent,
    BackButtonComponent,
    OutbountLinkIconComponent,
    TimeInputComponent,
    TruckTypeInputComponent,
    WarehouseTransactionTypeInputComponent,
    TransporterInputComponent,
    ImporterInputComponent,
    PhysicalExaminationGroupInputComponent,
    WarehouseTransactionGroupInputComponent,
    PhysicalExamInputCategoryComponent,
    LoadTypeInputComponent,
    ContainerSizeInputComponent,
    PermissionLevelInputComponent,
    CargoCategoryInputComponent,
    PurposeInputComponent,
    ClearingCompanyInputComponent,
    UnitOfMeasureInputComponent,
    LoadingFormatInputComponent,
    CommodityInputComponent,
    WarehouseInputComponent,
    ParkingBaySectionInputComponent,
    CommodityCategoryInputComponent,
    PackagingInputComponent,
    TransmissionInputComponent,
    MoneyInputComponent,
    ParkingBayInputComponent,
    DisabledLabelComponent,
    NumberToWordsPipe,
    RouterModule,
  ],

})
export class SharedModule { }
